/*
 * @providesModule EmailSignInStyle
 */

import {Dimensions, StyleSheet} from 'react-native';
import Sizes from 'Sizes';

const regularFontSize = Sizes.isTablet() ? 19 : 16;
const smallFontSize = Sizes.isTablet() ? 14 : 12;
const largeTextFont = Sizes.isTablet() ? 24 : 20;
const componentWidth = Sizes.isTablet() ? 374 : 311;
const WEBVIEW_TOP = 50;
const defaultColor = '#4890E8';

const defaultStyles = StyleSheet.create({
  container: {
    alignItems: 'center',
    backgroundColor: '#ffffff',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    alignSelf: 'center',
  },

  inputContainer: {},
  inputLabel: {},

  containerScrollview: {
    backgroundColor: '#ffffff',
    height: '100%',
    width: '100%',
    paddingTop: 1,
  },

  loginText: {
    fontSize: regularFontSize,
    alignSelf: 'center',
    fontFamily: 'OpenSans-SemiBold',
    color: '#ffffff',
  },

  headerText: {
    color: 'rgba(0,0,0,1)',
    fontSize: largeTextFont,
    alignSelf: 'center',
    fontFamily: 'OpenSans-Bold',
    width: componentWidth,
    marginBottom: Sizes.isTablet() ? 20 : 16,
  },
  skillzLoginSection: {
    marginTop: Sizes.isTablet() ? 32 : 24,
  },

  inputView: {
    marginBottom: Sizes.isTablet() ? 20 : 16,
    width: componentWidth,
    height: Sizes.isTablet() ? 77 : 62,
    flexDirection: 'row',
    backgroundColor: '#ffffff',
    alignSelf: 'center',
  },

  forgotBtn: {
    fontFamily: 'OpenSans-SemiBold',
    fontSize: Sizes.isTablet() ? 16 : 14,
    marginTop: Sizes.isTablet() ? 20 : 16,
    color: '#4890e8',
    marginBottom: 16,
    alignSelf: 'center',
  },

  loginBtn: {
    width: componentWidth,
    borderRadius: Sizes.isTablet() ? 29 : 24,
    height: Sizes.isTablet() ? 58 : 48,
    marginTop: 10,
    justifyContent: 'center',
    backgroundColor: '#4890E8',
    alignSelf: 'center',
  },

  termsOfServiceText: {
    color: '#000',
    fontSize: 12,
    opacity: 0.6,
    fontWeight: '400',
    textAlign: 'center',
    width: componentWidth,
    alignSelf: 'center',
    marginTop: 8,
    flexDirection: 'row',
    flexWrap: 'wrap',
  },

  passwordIcon: {
    marginRight: 12,
    marginLeft: 8,
    top: 2,
    tintColor: 'rgba(0,0,0,.3)',
    height: 24,
    width: 24,
  },

  textInInput: {
    left: 12,
    fontSize: regularFontSize,
    fontFamily: 'OpenSans-Regular',
  },

  toastContainer: {
    width: '100%',
    position: 'absolute',
    marginBottom: 85,
    bottom: 40,
  },

  tosView: {
    height: Dimensions.get('screen').height - WEBVIEW_TOP,
    width: Dimensions.get('window').width,
    position: 'absolute',
    top: 0,
  },

  hyperlinkStyle: {
    color: defaultColor,
    textAlignVertical: 'bottom',
    fontFamily: 'OpenSans-Regular',
    fontWeight: '400',
  },

  footerTextStyle: {
    fontSize: smallFontSize,
    lineHeight: regularFontSize,
    color: '#000000',
    fontFamily: 'OpenSans-Regular',
    textAlign: 'center',
  },
});

const darkStyles = StyleSheet.create({
  container: {
    ...defaultStyles.container,
    backgroundColor: '#1B1B1B',
  },
  containerScrollview: {
    ...defaultStyles.containerScrollview,
    backgroundColor: '#1B1B1B',
  },
  headerText: {
    ...defaultStyles.headerText,
    color: '#fff',
  },
  inputView: {
    ...defaultStyles.inputView,
    backgroundColor: '#1B1B1B',
  },
  textInInput: {
    ...defaultStyles.textInInput,
    color: '#fff',
  },
  footerTextStyle: {
    ...defaultStyles.footerTextStyle,
    color: '#fff',
  },
  termsOfServiceText: {
    ...defaultStyles.termsOfServiceText,
    opacity: 0.8,
  },
  inputContainer: {
    borderColor: '#DDDAD6',
  },
  passwordIcon: {
    tintColor: '#fff',
  },
  inputLabel: {
    color: '#fff',
  },
});

export const getStyles = (colorVariant?: 'dark') => {
  switch (colorVariant) {
    case 'dark':
      return {
        ...defaultStyles,
        ...darkStyles,
      };
    default:
      return defaultStyles;
  }
};

export default defaultStyles;
